<template>
  <div class="custom-button">
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label">Button Label</label>
        </div>
      </div>
      <div class="column is-5">
        <div class="field">
          <label class="label">Link to form</label>
        </div>
      </div>
      <div class="column is-3" v-if="groups">
        <div class="field">
          <label class="label">Association</label>
        </div>
      </div>
    </div>
    <div v-for="item in value" :key="item.buttonID" class="columns">
      <template v-if="!item.deleted">
        <div class="column is-3">
          <div class="field">
            <div class="control">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <input
                  v-model="item.title"
                  class="input"
                  type="text"
                  aria-label="Button Label"
                  :class="{ 'is-danger': failed }"
                />
                <p class="help is-danger">{{ errors[0] }}</p>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="column is-5">
          <div class="field">
            <div class="control">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <input
                  v-model="item.titleLink"
                  class="input"
                  :class="{ 'is-danger': failed }"
                  type="text"
                  aria-label="Link to form"
                />
                <p class="help is-danger">{{ errors[0] }}</p>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="column is-3" v-if="groups">
          <div class="field">
            <div class="control">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <div class="select" :class="{ 'is-danger': failed }">
                  <select v-model="item.groupID">
                    <option
                      v-for="r in groups"
                      :key="r.groupID"
                      :value="r.groupID"
                      :disabled="r.disabled"
                      v-html="r.name"
                    >
                    </option>
                  </select>
                </div>
                <p class="help is-danger">{{ errors[0] }}</p>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="column is-1">
          <button class="button is-secondary" @click="deleteButton(item)">
            <span class="icon-delete"></span>
          </button>
        </div>
      </template>
    </div>
    <div v-if="nActive < 3">
      <button class="button is-secondary" @click="addButton">
        <span class="icon-add"></span>&nbsp;&nbsp;&nbsp;
        <span>Add a form response button to another team</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonListManage',
  props: ['groups', 'value', 'oid'],
  data() {
    return {};
  },
  mounted() {},
  computed: {
    nActive() {
      let count = 0;
      for (let i = 0; i < this.value.length; i++) {
        if (this.value.deleted) continue;
        count++;
      }
      return count;
    }
  },
  methods: {
    addButton() {
      this.value.push({
        title: '',
        titleLink: '',
        groupID: '',
        organizationID: this.oid
      });
    },
    deleteButton(button) {
      for (let i = 0; i < this.value.length; i++) {
        if (this.value[i] == button) {
          if (this.value[i].buttonID) {
            this.$set(this.value[i], 'deleted', true);
            //this.value.deleted = true;
          } else {
            this.value.splice(i, 1);
          }
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>
